import type { KcContextAuthExtention } from 'types';

export function getAuthenticatorFromAuth<T>(auth: KcContextAuthExtention<T>) {
  return auth.authenticationSelections[0]?.authenticationExecution?.authenticator;
}
